export const ALLOWED_ICONS = [
    'ri-restaurant-2-line',
    'ri-restaurant-line',
    'ri-restaurant-fill',
    'ri-bowl-line',
    'ri-bowl-fill',
    'ri-cake-line',
    'ri-cake-2-line',
    'ri-cake-3-line',
    'ri-cup-line',
    'ri-cup-fill',
    'ri-leaf-line',
    'ri-seedling-line',
    'ri-apple-line',
    'ri-goblet-line',
    'ri-goblet-fill',
    'ri-drinks-line',
    'ri-beer-line',
    'ri-fire-line',
    'ri-knife-line',
    'ri-fridge-line',
    'ri-star-line',
    'ri-heart-line',
    'ri-emotion-happy-line',
    'ri-contrast-drop-line',
];

export const COLOR_PALETTE = {
    orange: {
        card: 'bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400',
        border: 'border-orange-300 dark:border-orange-700',
        swatch: 'bg-orange-500',
    },
    indigo: {
        card: 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400',
        border: 'border-indigo-300 dark:border-indigo-700',
        swatch: 'bg-indigo-500',
    },
    pink: {
        card: 'bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400',
        border: 'border-pink-300 dark:border-pink-700',
        swatch: 'bg-pink-500',
    },
    blue: {
        card: 'bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400',
        border: 'border-blue-300 dark:border-blue-700',
        swatch: 'bg-blue-500',
    },
    green: {
        card: 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400',
        border: 'border-green-300 dark:border-green-700',
        swatch: 'bg-green-500',
    },
    amber: {
        card: 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400',
        border: 'border-amber-300 dark:border-amber-700',
        swatch: 'bg-amber-500',
    },
    purple: {
        card: 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300',
        border: 'border-purple-300 dark:border-purple-700',
        swatch: 'bg-purple-500',
    },
    red: {
        card: 'bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400',
        border: 'border-red-300 dark:border-red-700',
        swatch: 'bg-red-500',
    },
    teal: {
        card: 'bg-teal-100 dark:bg-teal-900/30 text-teal-600 dark:text-teal-400',
        border: 'border-teal-300 dark:border-teal-700',
        swatch: 'bg-teal-500',
    },
    cyan: {
        card: 'bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 dark:text-cyan-400',
        border: 'border-cyan-300 dark:border-cyan-700',
        swatch: 'bg-cyan-500',
    },
    rose: {
        card: 'bg-rose-100 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400',
        border: 'border-rose-300 dark:border-rose-700',
        swatch: 'bg-rose-500',
    },
    lime: {
        card: 'bg-lime-100 dark:bg-lime-900/30 text-lime-600 dark:text-lime-400',
        border: 'border-lime-300 dark:border-lime-700',
        swatch: 'bg-lime-500',
    },
    emerald: {
        card: 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400',
        border: 'border-emerald-300 dark:border-emerald-700',
        swatch: 'bg-emerald-500',
    },
    violet: {
        card: 'bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-400',
        border: 'border-violet-300 dark:border-violet-700',
        swatch: 'bg-violet-500',
    },
    fuchsia: {
        card: 'bg-fuchsia-100 dark:bg-fuchsia-900/30 text-fuchsia-600 dark:text-fuchsia-400',
        border: 'border-fuchsia-300 dark:border-fuchsia-700',
        swatch: 'bg-fuchsia-500',
    },
    sky: {
        card: 'bg-sky-100 dark:bg-sky-900/30 text-sky-600 dark:text-sky-400',
        border: 'border-sky-300 dark:border-sky-700',
        swatch: 'bg-sky-500',
    },
    yellow: {
        card: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-300',
        border: 'border-yellow-300 dark:border-yellow-700',
        swatch: 'bg-yellow-500',
    },
    slate: {
        card: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400',
        border: 'border-slate-300 dark:border-slate-700',
        swatch: 'bg-slate-500',
    },
    stone: {
        card: 'bg-stone-100 dark:bg-stone-900/30 text-stone-600 dark:text-stone-400',
        border: 'border-stone-300 dark:border-stone-700',
        swatch: 'bg-stone-500',
    },
    zinc: {
        card: 'bg-zinc-100 dark:bg-zinc-900/30 text-zinc-600 dark:text-zinc-400',
        border: 'border-zinc-300 dark:border-zinc-700',
        swatch: 'bg-zinc-500',
    },
};

export const ALLOWED_COLOR_KEYS = Object.keys(COLOR_PALETTE);

export const getColorStyles = (colorKey) => COLOR_PALETTE[colorKey] || COLOR_PALETTE.slate;

export const getCategoryStyles = (category) => {
    if (!category) {
        return {
            icon: 'ri-restaurant-2-line',
            ...getColorStyles('slate'),
        };
    }

    return {
        icon: category.icon || 'ri-restaurant-2-line',
        ...getColorStyles(category.colorKey),
    };
};

export const sortCategories = (categories = []) => {
    return [...categories].sort((a, b) => {
        if (a.sortOrder !== b.sortOrder) {
            return a.sortOrder - b.sortOrder;
        }
        return a.name.localeCompare(b.name);
    });
};

export const findCategoryById = (categories, categoryId) => {
    if (!categoryId || !categories?.length) {
        return null;
    }
    return categories.find((category) => category._id === categoryId || category._id?.toString() === categoryId?.toString()) || null;
};
